/* ==========================================================================
   Wereld-uitspraak: de regels komen zacht binnen zodra de zin in beeld komt

   Faden en een lichte stijging, per regel gestaffeld, eenmalig. Zonder
   animatie (en dus meteen de eindstand) bij: geen data-wu-animatie,
   verminderde beweging, of een GSAP dat niet laadt. data-wu-klaar haalt de
   verberg-regel uit wereld-uitspraak.css weg.

   Ruimt zichzelf op bij verwijderen (shopify:section:unload) en start
   opnieuw bij terugplaatsen (shopify:section:load): zie wereld-hero.js.
   ========================================================================== */

/* Eén keer per pagina uitgevoerd in een eigen scope: een sectie die twee keer
   op de pagina staat laadt dit bestand twee keer, en een klasse op het niveau
   van het bestand zou dan een fout geven. */
(() => {
  class WereldUitspraak extends HTMLElement {
    connectedCallback() {
      this.gestart = false;
      this.stopVoorkeur = window.elGsap?.opVoorkeurWijziging(() => this.opnieuw());
      // Over de grens van 990 px wisselt de scroller (zie scroller()): opnieuw opbouwen
      this.breedte = window.matchMedia('(min-width: 990px)');
      this.naBreedte = () => this.opnieuw();
      this.breedte.addEventListener('change', this.naBreedte);
      this.start();
    }

    disconnectedCallback() {
      this.stopVoorkeur?.();
      this.breedte?.removeEventListener('change', this.naBreedte);
      this.opruimen();
    }

    /* Vanaf 990 px scrolt in dit thema .page-wrapper en niet het venster
       (base.css): ScrollTrigger moet dat element als scroller krijgen, anders
       reageert hij nooit. Onder 990 px scrolt het venster. */
    scroller() {
      const pagina = document.querySelector('.page-wrapper');
      return pagina && /(auto|scroll)/.test(getComputedStyle(pagina).overflowY) ? pagina : window;
    }

    opnieuw() {
      this.opruimen();
      this.start();
    }

    opruimen() {
      this.gestart = false;
      this.context?.revert();
      this.context = null;
    }

    async start() {
      if (this.gestart) return;
      this.gestart = true;

      const uitgezet = !this.hasAttribute('data-wu-animatie');
      if (uitgezet || !window.elGsap || window.elGsap.verminderdeBeweging()) {
        this.setAttribute('data-wu-klaar', '');
        return;
      }

      try {
        const { gsap, SplitText, ScrollTrigger } = await window.elGsap.laad(this, ['SplitText', 'ScrollTrigger']);
        if (document.fonts?.ready) await document.fonts.ready;
        if (!this.isConnected || !this.gestart) return;

        const scroller = this.scroller();
      const tekst = this.querySelector('[data-wu-tekst]');
        if (!tekst || !SplitText || !ScrollTrigger) {
          this.setAttribute('data-wu-klaar', '');
          return;
        }

        this.context = gsap.context(() => {
          SplitText.create(tekst, {
            type: 'lines',
            autoSplit: true,
            onSplit: (zelf) => {
              gsap.set(zelf.lines, { opacity: 0, y: 22 });
              this.setAttribute('data-wu-klaar', '');
              return gsap.to(zelf.lines, {
                opacity: 1,
                y: 0,
                duration: 1.1,
                ease: 'power3.out',
                stagger: 0.14,
                scrollTrigger: {
                  scroller,
                  trigger: tekst,
                  start: 'top 85%',
                  once: true,
                  invalidateOnRefresh: true,
                },
              });
            },
          });
        }, this);
      } catch {
        this.setAttribute('data-wu-klaar', '');
      }
    }
  }

  if (!customElements.get('wereld-uitspraak')) {
    customElements.define('wereld-uitspraak', WereldUitspraak);
  }
})();
